import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
Vue.use(Vuex)
const vuexLocal = new VuexPersistence({
  storage: window.localstorage
})
const store = new Vuex.Store({
  state: {
    subject: 1, // 1 教师资格证-笔试 、 2 教师资格证-面试、3 教师招聘-笔试、4 教师招聘-面试、1,2 教师资格证、3,4 教师招聘 多个使用,号拼接
    period: 2, // 学段 1中学 2小学 3幼儿  多个使用,号拼接
    name: '', // 用户姓名
    nickname: '', // 用户昵称
    portrait: '', // 用户头像
    province: '', // 报考省份
    school: '', // 所在分校名称
    token: '', // 用户认证凭证-秘钥
    uid: '', // 用户认证凭证-用户id
    userid: '', // 保利威视传参-用户id
    vipname: null, // vip等级名称
    viptime: null, // vip到期时间
    loginname: '', // 记录登录用户名
    logintel: '', // 记录登录手机号
    tempdata: {}, // 临时数据
    activedata: '1' // 数据来源
  },
  getters: {
    getStateSubject: state => state.subject,
    getStatePeriod: state => state.period,
    getStateName: state => state.name,
    getStateNickname: state => state.nickname,
    getStatePortrait: state => state.portrait,
    getStateProvince: state => state.province,
    getStateSchool: state => state.school,
    getStateToken: state => state.token,
    getStateUid: state => state.uid,
    getStateUserid: state => state.userid,
    getStateVipname: state => state.vipname,
    getStateViptime: state => state.viptime,
    getStateLoginName: state => state.loginname,
    getStateLoginTel: state => state.logintel,
    getStateTempData: state => state.tempdata,
    getStateActiveData: state => state.activedata
  },
  mutations: {
    alterStateSubject (state, value) {
      state.subject = value
    },
    alterStatePeriod (state, value) {
      state.period = value
    },
    alterStateName (state, value) {
      state.name = value
    },
    alterStateNickname (state, value) {
      state.nickname = value
    },
    alterStatePortrait (state, value) {
      state.portrait = value
    },
    alterStateProvince (state, value) {
      state.province = value
    },
    alterStateSchool (state, value) {
      state.school = value
    },
    alterStateToken (state, value) {
      state.token = value
    },
    alterStateUid (state, value) {
      state.uid = value
    },
    alterStateUserid (state, value) {
      state.userid = value
    },
    alterStateVipname (state, value) {
      state.vipname = value
    },
    alterStateViptime (state, value) {
      state.viptime = value
    },
    alterStateLoginName (state, value) {
      state.loginname = value
    },
    alterStateLoginTel (state, value) {
      state.logintel = value
    },
    alterStateTempData (state, value) {
      state.tempdata = value
    },
    alterStateActiveData (state, value) {
      state.activedata = value
    }
  },
  actions: {
    alterSubject (context, value) {
      context.commit('alterStateSubject', value)
    },
    alterPeriod (context, value) {
      context.commit('alterStatePeriod', value)
    },
    alterName (context, value) {
      context.commit('alterStateName', value)
    },
    alterNickname (context, value) {
      context.commit('alterStateNickname', value)
    },
    alterPortrait (context, value) {
      context.commit('alterStatePortrait', value)
    },
    alterProvince (context, value) {
      context.commit('alterStateProvince', value)
    },
    alterSchool (context, value) {
      context.commit('alterStateSchool', value)
    },
    alterToken (context, value) {
      context.commit('alterStateToken', value)
    },
    alterUid (context, value) {
      context.commit('alterStateUid', value)
    },
    alterUserid (context, value) {
      context.commit('alterStateUserid', value)
    },
    alterVipname (context, value) {
      context.commit('alterStateVipname', value)
    },
    alterViptime (context, value) {
      context.commit('alterStateViptime', value)
    },
    alterLoginName (context, value) {
      context.commit('alterStateLoginName', value)
    },
    alterLoginTel (context, value) {
      context.commit('alterStateLoginTel', value)
    },
    alterTempData (context, value) {
      context.commit('alterStateTempData', value)
    },
    alterActiveData (context, value) {
      context.commit('alterStateActiveData', value)
    }
  },
  plugins: [
    vuexLocal.plugin
  ]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js